<script setup>
import { computed } from 'vue';

const props = defineProps({
  priority: { type: String, default: '' },
});

// Fixed reference colors: intentionally independent of appearance tokens.
const color = computed(
  () =>
    ({ urgent: '#ff426d', high: '#ff8618', medium: '#ffd447', low: '#a1a1aa' })[
      props.priority
    ] || '#85858f'
);
const isFlag = computed(() =>
  ['low', 'medium', 'high'].includes(props.priority)
);
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="isFlag">
      <path d="M4 21V4" />
      <path
        d="M4 4C9 1 14 7 21 4V16C14 19 9 13 4 16Z"
        :fill="priority === 'high' ? color : 'none'"
      />
      <path
        v-if="priority === 'medium'"
        d="M4 10C9 7 14 13 21 10V16C14 19 9 13 4 16Z"
        :fill="color"
        stroke="none"
      />
    </template>
    <template v-else-if="priority === 'urgent'">
      <path d="M3 21V6C6 4 9 7 12 6M3 14C5 12 7 14 9 14" />
      <circle cx="16" cy="15" r="5" />
      <path d="M16 12.5V15.5M16 18H16.01M17 3V1M21 5L22.5 3.5M23 9L21.5 9.5" />
    </template>
    <template v-else>
      <path d="M4 21V9M9 4C13 4 16 7 21 4V14M4 16C7 14 9 15 11 15M3 3L22 22" />
    </template>
  </svg>
</template>
